/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';

/**
 * 
 * @export
 * @interface BoolAttributeDTO
 */
export interface BoolAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof BoolAttributeDTO
     */
    attributeName: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof BoolAttributeDTO
     */
    attributeType: AttributeTypeDTO;
    /**
     * 
     * @type {boolean}
     * @memberof BoolAttributeDTO
     */
    value: boolean;
}



/**
 * Check if a given object implements the BoolAttributeDTO interface.
 */
export function instanceOfBoolAttributeDTO(value: object): value is BoolAttributeDTO {
    if (!('attributeName' in value) || value['attributeName'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function BoolAttributeDTOFromJSON(json: any): BoolAttributeDTO {
    return BoolAttributeDTOFromJSONTyped(json, false);
}

export function BoolAttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoolAttributeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeName': json['attributeName'],
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
        'value': json['value'],
    };
}

export function BoolAttributeDTOToJSON(value?: BoolAttributeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeName': value['attributeName'],
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
        'value': value['value'],
    };
}

